import { localStrings } from './localization'
export const getStringByTextKey = (key, ...params) => {
  let value = localStrings
  let items = key.split('.')
  if (!items.length) {
    return ''
  }

  items.forEach(el => {
    value = value[el]
  })

  if (!params.length) {
    return value
  }

  params.forEach((param, idx) => {
    value = value.replace('{' + idx + '}', param)
  })

  return value
}



// WEBPACK FOOTER //
// ./src/utils/getStringByTextKey.js